import { IconSearch } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import styles from '../../styles/admin/Main.module.scss'
import BaseButton from '../common/SaveButton'
import SearchInput from '../common/SearchInput'
import Dropdown from '../common/Select'
import { LectureQuestionData } from '../../types/lectures'

interface HeaderSectionProps {
  selectedLevel: string
  onLevelChange: (value: string) => void
  data: LectureQuestionData[]
  currentPage: number
}
const HeaderSection = ({
  selectedLevel,
  onLevelChange,
  data,
  currentPage,
}: HeaderSectionProps) => {
  const navigate = useNavigate()



  const handleVideoCreateClick = () => {

    navigate('/lectures/lecture/create', {
      state: {fromPage: currentPage, level:data[0].LEVEL },
    })
  }

  const handleQuestionCreateClick = () => {

    navigate('/lectures/quiz/create', {
      state: {fromPage: currentPage, level:data[0].LEVEL },
    })
  }

  return (
    <div className={styles.headerSection}>
      <div className={styles.leftSection}>
        <p>Class List</p>
        <Dropdown value={selectedLevel} onChange={onLevelChange} />
      </div>
      <div className={styles.rightSection}>
        <BaseButton
          className={styles.createButton}
          onClick={handleVideoCreateClick}
        >
          Video
        </BaseButton>
        <BaseButton
          className={styles.createButton}
          onClick={handleQuestionCreateClick}
        >
          Question
        </BaseButton>
      </div>
    </div>
  )
}

export default HeaderSection
